import React from 'react';
import { IoCloseOutline } from "react-icons/io5";

const GalleryModal = ({ header, paragraph, isOpen, onClose }) => {
    if (!isOpen) {
        return null;
    }

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
            <div className="bg-white md:w-[60%] w-[94%] md:h-[60dvh] h-[84dvh]  rounded-[20px] relative shadow-lg p-4">
                <button 
                    className="absolute right-3 top-2" 
                    onClick={onClose}
                    aria-label="Close modal"
                >
                    <IoCloseOutline size={29} />
                </button>
                <div className='text-[#000] w-full h-full flex flex-col items-center md:px-5 justify-start md:mt-10 mt-5'><h1 className='md:text-[30px] text-[24px] text-[#b86a57]'>{header}</h1><p className=' md:text-center md:text-[20px] text-[15px] font-worksans text-[#9e9a83] font-medium'>{paragraph}</p></div>
            </div>
        </div>
    );
};

export default GalleryModal;
